import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';
import { ReleaseEnvironment } from 'types/releaseEnvironment';
import { ReleaseTask } from 'types/releaseTask';

/**
 * タスク一覧画面の状態
 */
interface ListState {
  /**
   * ロード中フラグ
   */
  loading: boolean;
  /**
   * 環境一覧
   */
  releaseEnvironments: ReleaseEnvironment[];
  /**
   * タスク一覧
   */
  releaseTasks: ReleaseTask[];
  /**
   * ターゲットグループリスト（選択用）
   */
  targetGroupList: string[];
  /**
   * 選択されたリリース
   */
  selectedReleaseTask: ReleaseTask | undefined;
}

/**
 * タスク一覧画面の初期状態
 */
const initialState: ListState = {
  loading: false,
  releaseTasks: [],
  targetGroupList: [],
  releaseEnvironments: [],
  selectedReleaseTask: undefined,
};

/**
 * タスク画面の slice(reducer + action)
 */
export const listSlice = createSlice({
  name: 'list',
  initialState,
  reducers: {
    init: () => initialState,
    loadStarted: (state) => {
      state.loading = true;
    },
    loadEnded: (state) => {
      state.loading = false;
    },
    fetchReleaseTaskSuccess: (
      state,
      action: PayloadAction<{
        releaseTasks: ReleaseTask[];
      }>,
    ) => {
      const { releaseTasks } = action.payload;
      state.releaseTasks = releaseTasks;
    },
    fetchTargetGrouopSuccess: (
      state,
      action: PayloadAction<{
        targetGroupList: string[];
      }>,
    ) => {
      const { targetGroupList } = action.payload;
      state.targetGroupList = targetGroupList;
    },
    fetchReleaseEnvironmentSuccess: (
      state,
      action: PayloadAction<{
        releaseEnvironments: ReleaseEnvironment[];
      }>,
    ) => {
      const { releaseEnvironments } = action.payload;
      // For component data Null
      const formData: ReleaseEnvironment[] = releaseEnvironments.map(
        (item) => ({
          components: item.components ? item.components : [],
          manifestVersion: item.manifestVersion,
          name: item.name,
          releasedAt: item.releasedAt,
        }),
      );
      state.releaseEnvironments = formData;
    },
  },
});

/**
 * タスク一覧画面の action
 */
export const listActions = listSlice.actions;

/**
 * タスク一覧画面の selector（内部用）
 */
const getloading = (state: RootState) => state.releaseTask.list.loading;

const getReleaseTasks = (state: RootState) =>
  state.releaseTask.list.releaseTasks;

/**
 * タスク一覧画面の selector
 */
export const listSelectors = {
  loading: getloading,
  releaseTasks: getReleaseTasks,
} as const;
